import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { EntityState } from '../../../entity/entity.reducer';
import { EntityTypes } from '../../../entity/entity-types';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { getDiagramPartListState } from '../part.reducer';
import { DiagramPart } from '../models/part';

const createState = (id: IdType) => createSelector(
  getDiagramPartListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createDiagramPartListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.diagramPart,
    EntityTypes.part
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.diagramPart]], entities) as DiagramPart[]
);

export const createDiagramPartListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createDiagramPartListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createDiagramPartListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createDiagramPartListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createDiagramPartListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
